import { defineStore } from 'pinia/dist/pinia'
import { loadEvaluations } from '@/service/Versorgungsatlas';

export const useEvaluationListStore = defineStore('evaluationList', {
    state: () => ({
        evaluationList: [],
        firstAuswid: null,
    }),
    getters: {
        getEvaluationById: (state) => {
            return (auswid) => state.evaluationList.find((evaluation) => parseInt(evaluation.auswid) === parseInt(auswid))
        },
        getFirstEvaluationAuswid() {
            return this.firstAuswid;
        },
    },
    actions: {
        updateStates() {
            this.evaluationList.sort(function(a, b){
                let keyA = a['auswertung'],
                    keyB = b['auswertung'];
                // Compare the 2 dates
                if(keyA < keyB) return -1;
                if(keyA > keyB) return 1;
                return 0;
            });
        },
        async loadEvaluations(force = false) {
            if ((this.evaluationList?.length === 0) || force === true) {
                const evaluations = await loadEvaluations()


                //Evaluations are sorted alphabetically
                var tmpEvaluations = evaluations.data;

                if (!tmpEvaluations || tmpEvaluations.length === 0) {
                    return;
                }

                tmpEvaluations.sort(function(a, b){
                    let keyA = a['auswertung'],
                        keyB = b['auswertung'];
                    // Compare the 2 dates
                    if(keyA < keyB) return -1;
                    if(keyA > keyB) return 1;
                    return 0;
                });
                this.firstAuswid = tmpEvaluations[0]['auswid'];

                this.evaluationList = evaluations.data ?? []

                this.updateStates();
            }
        },
        loadFirstAuswid() {
          return this.evaluationList.length;
        }
    }
})